<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active"><a href="#">Enquery</a></li>
        </ol>
        <div class="row" v-if="showAddEnq">
          <div class="col-md-12">
            <div class="outer-quryBUTN ordercret-table">
              
              <div class="col-md-6 col-md-offset-6">
                <div class="right-quryADD">
                  <ul>
                    <li>
                      <router-link to="/enquiry"><i class="material-icons">add</i> Add</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- table Part -->
        <div class="row">
          <div class="col-md-12">
            <div class="panel panel-default" id="panel-inline">
              <div class="panel-heading">
                <div class="panel-ctrls"></div>
              </div>
              <div class="panel-body no-padding">
                <div class="col-md-3">
                  <div id="search-box">
                    <div class="form-group">
                      <input
                        type="text"
                        class="search-query form-control"
                        placeholder="Search"
                        v-model="searchText"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <button
                      type="button"
                      v-on:click="getAllLeads(1)"
                      class="btn btn-outline-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
                <table
                  class="table table-striped table-bordered"
                  cellspacing="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Enquiry Number</th>
                      <th>Model</th>
                      <th>Customer Name</th>
                      <th>Contact Number</th>
                      <th>Enquiry Date</th>
                      <th>Comments</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  <!-- <tr class="odd gradeX"> -->
                  <tr
                    v-for="(item, index) in users_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>{{ item.EnqueryID }}</td>
                    <td>{{ item.Model }}</td>
                    <td>{{item.FirstName+" "+item.MiddleName+ " "+item.LastName}}</td>
                    <td>{{item.MobileNumber}}</td>
                    <td>{{format_date(item.created_date)}}</td>
                    <td>{{item.Comments | truncate(10,'...') }}</td>
                    <td class="statusLIATopan"><a href="#">Open</a></td>
                   
                  </tr>
                </tbody>
                </table>
                <!--end table-->
              </div>
              <div class="panel-footer">
                <paginate
                  :page-count="TotalPage"
                  :click-handler="getAllLeads"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                >
                </paginate>
              </div>
            </div>
          </div>
        </div>
        <!--  table part / -->
      </div>
    </div>
    <div id="externalScript"></div>
  </div>
</template>
<script>
import moment from 'moment'

import Paginate from 'vuejs-paginate';
import postscribe from 'postscribe';
import commonServices from '../services/common-services';
export default {
  name: 'enqueryList',
  data() {
    return {
      users_data: [],
      TotalPage: 1,
      searchText: '',
      pageSize: 5,
      currentPage: 1,
      showAddEnq:false
    };
  },
  components: {
    Paginate,
  },
  methods: {
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    getAllLeads(pageNum) {
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      commonServices
        .get('bajajAPI/Enquery/list', params)
        .then((response) => {
          const {
            users_data,
            totalItems,
            currentPage,
            TotalPage,
          } = response.data;
          this.users_data = users_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
    },
    format_date(value){
         if (value) {
           return moment(String(value)).format('DD-MM-YYYY')
          }
      },
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  mounted() {
     
     const menuList = this.$store.state.common.globalmenues
     menuList.forEach(element => {
      if(element.url === '/enquiry'){
        this.showAddEnq = true
      }
    });

    this.getAllLeads(1),
    postscribe(
      '#externalScript',
      /* eslint-disable-next-line */
      `<\script type="application/javascript" src="assets/js/Utility_ApplicationUsed.js"><\/script>`
    );
  },
  filters: {
        truncate: function (text, length, suffix) {
            if(!text){
              return text;
            }
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }
};
</script>
